// Constantes y fórmulas compartidas por la página admin (Vendedores CSCC) y
// la página pública de pago (/vendor-pay). La misma fórmula vive en
// functions/csccVendors.js; si cambia una, cambiar la otra.

export const VENDORS_COLLECTION = 'cscc-vendors';
export const SETTINGS_COLLECTION = 'cscc-vendor-settings';
export const SETTINGS_DOC = 'current';

const FN = 'https://us-central1-bb-target-center.cloudfunctions.net';
export const FN_URLS = {
  sendLink: `${FN}/csccVendorSendLink`,
  recordPayment: `${FN}/csccVendorRecordPayment`,
  get: `${FN}/csccVendorGet`,
  save: `${FN}/csccVendorSave`,
  createIntent: `${FN}/csccVendorCreateIntent`,
  confirmPayment: `${FN}/csccVendorConfirmPayment`,
  uploadDoc: `${FN}/csccVendorUploadDoc`,
  uploadAgreement: `${FN}/csccAgreementUpload`,
};

// Los precios de los acuerdos ya incluyen el IVU (11.5 %); se desglosa hacia atrás.
export const TAX_RATE = 0.115;
export function taxBreakdown(totalCents) {
  const total = Number(totalCents) || 0;
  const subtotalCents = Math.round(total / (1 + TAX_RATE));
  return { subtotalCents, taxCents: total - subtotalCents };
}

export const DOC_TYPES = {
  signedAgreement: 'Acuerdo firmado',
  artisanCertificate: 'Certificado de artesano',
  merchantRegistration: 'Registro de comerciante',
};
export const DOC_KEYS = Object.keys(DOC_TYPES);

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export const PUBLIC_PAY_BASE = 'https://bbtc-dashboard.web.app/vendor-pay';

export const TYPE_LABELS = {
  emprendedor: 'Emprendedor · carpa 10 × 10',
  artesano: 'Artesano · carpa 10 × 10',
  carpa_comida: 'Carpa de comida',
  food_truck: 'Food truck',
};
export const TYPE_KEYS = Object.keys(TYPE_LABELS);

export const STATUS_LABELS = {
  draft: 'Borrador',
  pending_deposit: 'Depósito pendiente',
  deposit_paid: 'Depósito pagado',
  paid: 'Pagado',
  cancelled: 'Cancelado',
};
export const STATUS_COLORS = {
  draft: 'default',
  pending_deposit: 'warning',
  deposit_paid: 'info',
  paid: 'success',
  cancelled: 'error',
};

export const METHOD_LABELS = { card: 'Tarjeta', cash: 'Efectivo', ath: 'ATH Móvil', other: 'Otro' };
export const KIND_LABELS = { deposit: 'Depósito', balance: 'Balance', full: 'Pago total', partial: 'Pago parcial' };

// Valores de los acuerdos V18 (emprendedores) y V16 (comidas y food trucks).
export const DEFAULT_SETTINGS = {
  eventName: 'Caribbean Sporting Clays Cup 2027',
  venue: 'The Village · Hacienda Ana Paola, Carolina, Puerto Rico',
  days: [
    { key: '2027-01-07', label: 'Jueves 7 de enero' },
    { key: '2027-01-08', label: 'Viernes 8 de enero' },
    { key: '2027-01-09', label: 'Sábado 9 de enero' },
    { key: '2027-01-10', label: 'Domingo 10 de enero' },
  ],
  types: {
    emprendedor: {
      enabled: true,
      dayPrices: { '2027-01-07': 50, '2027-01-08': 50, '2027-01-09': 70, '2027-01-10': 70 },
      packagePrice: 200,
      flatPrice: 0,
      depositPercent: null,
      agreementUrl: 'https://firebasestorage.googleapis.com/v0/b/bb-target-center.appspot.com/o/cscc-agreements%2FAcuerdo-Emprendedores-CSCC-2027.pdf?alt=media&token=aeaadb94-96a4-44c9-87c7-5f75b0454ead',
    },
    // Artesanos: solo se les puede cobrar $25 por todo el evento, pago completo el 25 de noviembre.
    artesano: {
      enabled: true,
      dayPrices: {},
      packagePrice: 0,
      flatPrice: 25,
      depositPercent: 100,
      agreementUrl: '',
    },
    carpa_comida: {
      enabled: true,
      dayPrices: { '2027-01-07': 150, '2027-01-08': 150, '2027-01-09': 200, '2027-01-10': 200 },
      packagePrice: 600,
      agreementUrl: 'https://firebasestorage.googleapis.com/v0/b/bb-target-center.appspot.com/o/cscc-agreements%2FAcuerdo-Comidas-y-Food-Trucks-CSCC-2027.pdf?alt=media&token=399eafe5-7d69-4ebc-a3ee-3ebcb2fbb796',
    },
    food_truck: {
      enabled: true,
      dayPrices: { '2027-01-07': 200, '2027-01-08': 200, '2027-01-09': 250, '2027-01-10': 250 },
      packagePrice: 750,
      agreementUrl: 'https://firebasestorage.googleapis.com/v0/b/bb-target-center.appspot.com/o/cscc-agreements%2FAcuerdo-Comidas-y-Food-Trucks-CSCC-2027.pdf?alt=media&token=399eafe5-7d69-4ebc-a3ee-3ebcb2fbb796',
    },
  },
  depositPercent: 25,
  depositDueDate: '2026-11-25',
  balanceDueDate: '2026-12-01',
  cancelTerms:
    'Cancelaciones: toda cancelación deberá notificarse por escrito. Hasta el 15 de diciembre de 2026 se retiene el 25% del costo total del espacio; a partir del 16 de diciembre de 2026 se retiene el 50%. Si los pagos realizados exceden el cargo, se reembolsa la diferencia.',
  emailIntro:
    'Gracias por tu interés en participar en The Village durante la Caribbean Sporting Clays Cup 2027 (7 al 10 de enero). Las tarifas incluyen únicamente el espacio; cada negocio trae su carpa o food truck y su equipo.',
  contactName: 'Paola Bermúdez',
  contactPhone: '787-585-2056',
  contactEmail: 'haciendaanapaola@gmail.com',
};

export const money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;
export const dollars = (cents) => (Number(cents) || 0) / 100;

export function fmtDateEs(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  return `${d} de ${months[m - 1]} de ${y}`;
}

// Snapshot de precios que se guarda en cada participante al crearlo.
export function pricingSnapshot(settings, type) {
  const t = (settings.types || {})[type] || {};
  return {
    days: (settings.days || []).map((d) => ({ key: d.key, label: d.label })),
    dayPrices: { ...(t.dayPrices || {}) },
    packagePrice: Number(t.packagePrice) || 0,
    flatPrice: Number(t.flatPrice) || 0,
  };
}

// % de depósito del tipo (si lo tiene) o el general.
export function depositPercentFor(settings, type) {
  const t = (settings.types || {})[type] || {};
  const own = Number(t.depositPercent);
  if (own > 0 && own <= 100) return own;
  return Number(settings.depositPercent) || 25;
}

export function computeTotals(vendor, selection) {
  const pricing = vendor.pricing || {};
  const dayPrices = pricing.dayPrices || {};
  const allDays = (pricing.days || []).map((d) => d.key);
  const fullPackage = selection.fullPackage === true;
  const days = fullPackage ? allDays : (selection.days || []).filter((k) => allDays.includes(k));
  const flatCents = Math.round(Number(pricing.flatPrice || 0) * 100);
  let totalCents = 0;
  if (flatCents > 0) totalCents = flatCents;
  else if (fullPackage) totalCents = Math.round(Number(pricing.packagePrice || 0) * 100);
  else totalCents = days.reduce((sum, k) => sum + Math.round(Number(dayPrices[k] || 0) * 100), 0);
  const pct = Number(vendor.depositPercent) > 0 ? Number(vendor.depositPercent) : 25;
  const depositCents = Math.round((totalCents * pct) / 100);
  return { days, fullPackage, totalCents, depositCents, balanceCents: totalCents - depositCents };
}

export function paidCents(vendor) {
  return (vendor.payments || []).reduce((s, p) => s + (Number(p.amountCents) || 0), 0);
}

export function randomToken() {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export async function callFn(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export function daysLabel(vendor) {
  const labels = {};
  ((vendor.pricing && vendor.pricing.days) || []).forEach((d) => { labels[d.key] = d.label; });
  if (vendor.pricing && Number(vendor.pricing.flatPrice) > 0) {
    const chosen = (vendor.days || []).map((k) => (labels[k] || k).replace(/ de enero$/, '')).join(', ');
    return `Tarifa única${chosen ? ` · ${chosen}` : ''}`;
  }
  if (vendor.fullPackage) return 'Paquete 4 días';
  if (!vendor.days || !vendor.days.length) return 'Por escoger';
  return vendor.days.map((k) => (labels[k] || k).replace(/ de enero$/, '')).join(', ');
}

// Descarga un CSV en el navegador (sin librería: react-csv no pasa el ref y
// rompe el Button de MUI).
export function downloadCsv(filename, rows) {
  if (!rows || !rows.length) return;
  const headers = Object.keys(rows[0]);
  const esc = (v) => {
    const str = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };
  const csv = [headers.join(','), ...rows.map((r) => headers.map((h) => esc(r[h])).join(','))].join('\n');
  const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Documentos obligatorios antes de pagar (misma regla que functions/csccVendors.js).
export function requiredDocs() {
  return ['signedAgreement', 'merchantRegistration'];
}
export function missingDocs(vendor) {
  const docs = vendor.documents || {};
  return requiredDocs(vendor).filter((k) => !docs[k]);
}
